
import Arrow2 from "../../../assets/outline/Arrow2.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Arrow2Icon({ className, dataTestid = "Arrow2Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Arrow2 data-testid={dataTestid} className={classes} {...rest} />
  );
}
